<template>
  <div class="order__tags">
    <div class="order__tag" v-for="tag in product.tags" :style="'background:' + tag.color ">{{ tag.name }}</div>
    <ComboTag :product-id="product.product_id" />
  </div>
</template>

<script>
import ComboTag from "@/components/element/ComboTag.vue";

export default {
  name: 'TheProductTags',

  components: {
    ComboTag
  },

  props: {
    product: {
      type: Object,
      require: true,
    }
  }
}
</script>